// extracted by mini-css-extract-plugin
module.exports = {"heart-icon":"ToggleFavouriteButton_heart-icon__2bCrj","green":"ToggleFavouriteButton_green__3V7sG","icon-only":"ToggleFavouriteButton_icon-only__4ZQa3"};